import { getCookie } from '../functions';
function attachPlayButtonEvents() {
    document.querySelectorAll('.is-play').forEach((button) => {
        button.addEventListener('click', onPlayClick);
    });
}

function onPlayClick(event) {
    const cardImage = event.target.closest('.card-image');
    var videoUrl = cardImage.getAttribute('data-video-url');
    const platform = cardImage.getAttribute('data-video-kind');
    const videoId = cardImage.getAttribute('data-video-id');
    const notification = cardImage.getAttribute('data-video-notification');
    const cookieChoice = getCookie('occ');

    if (cookieChoice == 'true') {
        cardImage.innerHTML = `
            <iframe width="1028" height="540"
                src="${videoUrl}" title="Video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                class="is-fullwidth is-fullheight" allowfullscreen>
            </iframe>
        `;
        //Need event for tagmanager so it can be hooked to a trigger for measuring youtube and vimeo play, stop, etc events
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'iframeLoaded_' + platform
        });
    } else {
        videoUrl = platform == "vimeo" ? videoUrl : "https://www.youtube.com/watch?v=" + videoId;

        cardImage.innerHTML += `
            <div class="notification container-clipped has-background-secondary has-radius is-info">
                <button class="delete"></button>
                <p>${notification}</p>
                <p><a href="${videoUrl}" target="_blank"> ${platform} video </a></p>
            </div>
        `;

        const newNotification = cardImage.querySelector('.notification');
        const deleteButton = newNotification.querySelector('.delete');

        deleteButton.addEventListener('click', () => {
            newNotification.remove();


            attachPlayButtonEvents();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    attachPlayButtonEvents();
});

